import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpResponseBase, HttpErrorResponse } from '@angular/common/http';
import { AppGlobals } from './app.global'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw'; // fixed typo
import { Router } from '@angular/router';
import { PopupMessageService } from './popupMessageService';

@Injectable()
export class WebService 
{
    private httpOptions: any;

    constructor(private http: HttpClient, private global: AppGlobals, private router: Router,public popupMessageService: PopupMessageService) 
    {
    }


    // token set in header
    SetTokenInHeader() 
    {
        let httpOptions: any;
        let objloggedUser = this.global.GetLoggedUserDetail();

        if(this.global.IsMow == 'false')
        {
            if (objloggedUser != null) 
            {
                httpOptions =
                    {
                        headers: new HttpHeaders
                            ({
                                'Content-Type': 'application/json',
                                'TokenValue': objloggedUser.TokenValue,
                                'IsMow': this.global.IsMow
                            })
                    };
            }
        }
        else
        {
            httpOptions =
                    {
                        headers: new HttpHeaders
                            ({
                                'Content-Type': 'application/json',
                                'TokenValue': this.global.MowToken,
                                'IsMow': this.global.IsMow
                            })
                    };
        }
        return httpOptions
    }


    GetWithoutHeader(route) {
        return this.http.get(this.global.baseAPIUrl + route).toPromise();
    }

    PostWithoutHeader(data, route) {
        return this.http.post(this.global.baseAPIUrl + route, data).toPromise();
    }

    Get(route) 
    {
        this.httpOptions = this.SetTokenInHeader();

        return this.http.get(this.global.baseAPIUrl + route, this.httpOptions).toPromise().catch(response =>  
            {

            if (response.status == 401) 
            {
                if(this.global.IsMow == 'true')
                {
                    this.popupMessageService.openWarningWithoutButtonSwal('Unauthorized', 'Token not verified');
                }
                else{
                    this.router.navigate(['/login']);
                }
                
            }
        });
        
    }

    Post(data, route) 
    {
        this.httpOptions = this.SetTokenInHeader();

        return this.http.post(this.global.baseAPIUrl + route, data, this.httpOptions).toPromise().catch(response => {
            if (response.status == 401) 
            {
                if(this.global.IsMow == 'true')
                {
                    this.popupMessageService.openWarningWithoutButtonSwal('Unauthorized', 'Token not verified');
                }
                else{
                    this.router.navigate(['/login']);
                }
            }
        });
    }

    Put(data, route) {
        this.httpOptions = this.SetTokenInHeader();

        return this.http.put(this.global.baseAPIUrl + route, data, this.httpOptions).toPromise().catch(response => {
            if (response.status == 401) 
            {
                if(this.global.IsMow == 'true')
                {
                    this.popupMessageService.openWarningWithoutButtonSwal('Unauthorized', 'Token not verified');
                }
                else{
                    this.router.navigate(['/login']);
                }
            }
        });
    }

    Delete(data, route) {
        this.httpOptions = this.SetTokenInHeader();

        return this.http.request('delete', this.global.baseAPIUrl + route, { body: data, headers: this.httpOptions.headers }).toPromise().catch(response => {
            if (response.status == 401) 
            {
                if(this.global.IsMow == 'true')
                {
                    this.popupMessageService.openWarningWithoutButtonSwal('Unauthorized', 'Token not verified');
                }
                else{
                    this.router.navigate(['/login']);
                }
            }
        });
    }


    private handleError(error: HttpErrorResponse) {
        return Observable.throw(error.message || 'Server error');
    }


}




// WEBPACK FOOTER //
// ./src/app/service/web.service.ts